import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Landing.css';

const Landing = ({ token, characterName, firstName }) => {
    const navigate = useNavigate();

    const title = token && (characterName || firstName)
        ? `Welcome back, ${characterName || firstName}!`
        : 'Welcome to Chronicles!';

    return (
        <div className="landing-page">
            <div className="welcome-section">
                <img className="welcome-logo" src="chronlogo-kobold.svg" alt="Chronicles" />
                <h1 className="welcome-title">{title}</h1>
                <p className="welcome-tagline">
                    A fantasy live-action roleplaying experience.
                </p>
                <p className="welcome-text">
                    Chronicles is a fantasy LARP where you create a character, build their story,
                    and live out epic adventures alongside a community of players.
                </p>
                <p className="welcome-text">
                    Sign in to manage your character, track your skills, and register for upcoming events.
                </p>
                <p className="welcome-text">
                    <a href="https://larpchronicles.com/discord" className="welcome-link"
                       target="_blank" rel="noopener noreferrer">Join us on Discord!</a>{' '}
                    Our server is the best place to get answers to questions, find out more
                    information, or even just to chat and hang out.
                </p>

                {!token && (
                    <button className="welcome-signin-btn" onClick={() => navigate('/login')}>
                        Sign In
                    </button>
                )}

                <p className="welcome-text welcome-browse">
                    Curious what's coming up? You can{' '}
                    <span className="welcome-link" onClick={() => navigate('/schedule')}>
                        check out the event schedule
                    </span>{' '}
                    without signing in.
                </p>
            </div>
        </div>
    );
};

export default Landing;
